module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-de-DE.df64d2b1.jpg";